export const restMethods = Object.freeze({
	PUT: 'put',
	POST: 'post',
	GET: 'get',
	DELETE: 'delete',
	PATCH: 'patch',
});

// Named export for destructured methods
export const { PUT, POST, GET, DELETE, PATCH } = restMethods;
